import { ICartItem, ShippingType } from "@gloria-public/order/domain/interfaces/cart.interface";

export interface IExposedOrder {
  id: number;
  billingAddress: string;
  billingAddressID: number;
  date?: string;
  status: OrderStatus;
  lastItemAddedAt: string;
  reminderSentAt: string;
  updatedAt: string;
}

export interface IModifyShippingDetails {
  billingAddressID?: number | null;
  shippingInformation: IItemShippingDetails[];
}

interface IItemShippingDetails {
  itemID: number;
  shippingType: ShippingType | null;
  shippingAddressID: string | null;
}

export enum OrderStatus {
  DRAFT = "DRAFT",
  PENDING_CHECKOUT = "PENDING_CHECKOUT",
  PAID = "PAID",
  PAYMENT_FAILED = "PAYMENT_FAILED",
}

export interface IOrdersHistoryFilters {
  lang: string;
  page?: number;
  pageSize?: number;
  sortByDate?: "ASCENDING" | "DESCENDING";
}

export interface IOrdersHistory {
  order: IExposedOrder;
  items: ICartItem[];
}
